module.exports = __webpack_public_path__ + "img/download_bg@3x.ddd566f9.png";